module.exports = __webpack_public_path__ + "static/media/Big-o-logo.0d889c79.jpg";